export enum ProposalDetailTab 
{
    INFORMACIONGENERAL = 0,
    INTEGRANTES = 1, 
    DESCRIPCION = 2, 
    BIBLIOGRAFIA = 3, 
    REPORTES = 4, 
    EVALUACIONES = 6 
}

export enum ProposalDetailHistoricTab 
{
    INFORMACIONGENERAL = 0,
    INTEGRANTES = 1, 
    REPORTES = 2, 
    BIBLIOGRAFIA = 3, 
}